<script setup lang="ts">
/**
 * 이사회 결의 "RESOLVED FURTHER THAT the said Directors’ Statement be signed by …" 분기 —
 *   [[if director_count == 1]] sole / [[else if == 2]] both / [[else]] [[if specify_signers]] 지정 서명자 목록 [[else]] any two.
 *   colon: AFS·Exempted 원문은 "signed by:" , UFS 원문은 "signed by" (콜론 없음).
 *   이사 수(엔티티에서 자동)·서명자 지정 토글은 상단 옵션 바 대신 이 문단 자리에서 바꾼다.
 */
import AgmRowsEditor from './AgmRowsEditor.vue';
import { useAgmStudio } from './agmStudioContext';

withDefaults(defineProps<{ colon?: boolean }>(), { colon: true });
const { model, lookup } = useAgmStudio();
function setCount(e: Event) {
  model.directorCount = Math.max(1, Math.floor(Number((e.target as HTMLInputElement).value) || 1));
}
</script>

<template>
  <div class="ds-wrap">
    <div class="ds-ctl">
      <span class="ds-lbl">Number of directors</span>
      <input class="ds-num" type="number" min="1" :value="model.directorCount" @change="setCount" />
      <button v-if="model.directorCount >= 3" type="button" class="ds-tg" :class="{ on: model.specifySigners }" @click="model.specifySigners = !model.specifySigners">
        {{ model.specifySigners ? '☑' : '☐' }} Specify who signs
      </button>
    </div>
    <p v-if="model.directorCount === 1" class="doc-p">RESOLVED FURTHER THAT the said Directors’ Statement be signed by the sole director pursuant to Section 201(15) of the Act.</p>
    <p v-else-if="model.directorCount === 2" class="doc-p">RESOLVED FURTHER THAT the said Directors’ Statement be signed by both directors pursuant to Section 201(15) of the Act.</p>
    <template v-else-if="model.specifySigners">
      <p class="doc-p">RESOLVED FURTHER THAT the said Directors’ Statement be signed by{{ colon ? ':' : '' }}</p>
      <AgmRowsEditor :rows="model.signers" add-label="+ Add signing director" placeholder="Director name"
        @lookup="(i: number) => lookup({ fieldGroup: 'signer', index: i, defaultRole: 'DIRECTOR' })" />
      <p class="doc-p">on behalf of the Board pursuant to Section 201(15) of the Act.</p>
    </template>
    <p v-else class="doc-p">RESOLVED FURTHER THAT the said Directors’ Statement be signed by any two directors pursuant to Section 201(15) of the Act.</p>
  </div>
</template>

<style scoped>
.ds-wrap { margin: 6px 0; padding-left: 8px; border-left: 3px solid #cfe0ff; }
.ds-ctl { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ds-lbl { font-size: 10.5px; font-weight: 700; color: #1b4fb0; background: #eef4ff; border: 1px solid #cfe0ff; border-radius: 999px; padding: 0 8px; line-height: 18px; }
.ds-num { width: 52px; border: 1px solid #cfe0ff; border-radius: 6px; padding: 0 6px; font: inherit; font-size: 11px; line-height: 18px; }
.ds-tg { border: 1px solid #d7dde8; background: #f4f6fa; color: #6b7a94; font-size: 10.5px; font-weight: 700; border-radius: 999px; padding: 0 8px; line-height: 18px; cursor: pointer; font-family: inherit; }
.ds-tg.on { border-color: #bfe6cf; background: #eafaf1; color: #14713f; }
</style>
